// extracted by mini-css-extract-plugin
export default {"status_container":"CustomizableServiceDeployment_status_container__C0dvf","status":"CustomizableServiceDeployment_status__m-V3v"};